import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { ExportTimeseriesModalComponent } from './export-timeseries-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
  declarations: [ExportTimeseriesModalComponent],
  exports: [ExportTimeseriesModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    MatDialogModule,MatDividerModule,MatIconModule,MatButtonModule
  ],
})
export class ExportTimeseriesComponentModule {}
